var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTee(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "572.8px",
    height: "91.2px",
    viewBox: "0 0 572.8 91.2",
    enableBackground: "new 0 0 572.8 91.2",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "background"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "golf_tee"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M0,45.6c0,17.7,1.6,33.7,4.3,45.6h27.4c6.3-5.9,15-10.6,26.2-14c5.6-1.7,12.9-3.6,22.4-5.9 c8.7-1.7,24.1-3.6,45.8-4.8c0.7,0,1.4,0,2.4-0.3l378.8-3.6l65.4-16.8l-65.4-17.3l-378.8-3.6c-1,0-1.7,0-2.4-0.3 c-21.7-1.1-37.1-2.8-45.8-4.8c-9.4-2.2-16.8-3.9-22.4-5.6C46.7,10.6,38,6.2,31.7,0L4.3,0C1.6,11.9,0,27.9,0,45.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTee);
export default __webpack_public_path__ + "static/media/tee.9b05934e.svg";
export { ForwardRef as ReactComponent };